import { render, staticRenderFns } from "./MyPurchase.vue?vue&type=template&id=1d0672fe&scoped=true&"
import script from "./MyPurchase.vue?vue&type=script&lang=js&"
export * from "./MyPurchase.vue?vue&type=script&lang=js&"
import style0 from "./MyPurchase.vue?vue&type=style&index=0&id=1d0672fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0672fe",
  null
  
)

export default component.exports